export const navigationConstants = {
    UPDATE_NAVIGATION_ITEMS : 'UPDATE_NAVIGATION_ITEMS'
};
